import * as tslib_1 from "tslib";
import { AppStateFacade, Setting, } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { isEmptyObject } from '@utils/audit.utils';
import difference from 'lodash-es/difference';
import intersection from 'lodash-es/intersection';
import * as moment from 'moment';
var AuditLogDataModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AuditLogDataModalComponent, _super);
    function AuditLogDataModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isEmptyObject = isEmptyObject;
        _this.changes = [];
        _this._translateService = _this._injector.get(TranslateService);
        _this._appState = _this._injector.get(AppStateFacade);
        _this.applyFormatting = function (value) {
            if (!!value &&
                !!value.translate) {
                return _this._translateService.instant(value.translate.key, value.translate.data);
            }
            if (value instanceof Date) {
                return _this.formatDate(value);
            }
            if (value == null ||
                value === '' ||
                isEmptyObject(value) ||
                value instanceof Array && value.length === 0) {
                return 'N/A';
            }
            if (value instanceof Array) {
                return value.map(_this.applyFormatting);
            }
            var keys = Object.keys(value);
            if (typeof value === 'object' &&
                keys.length) {
                var o_1 = {};
                keys.forEach(function (k) { return o_1[k] = _this.applyFormatting(value[k]); });
                return o_1;
            }
            return value;
        };
        return _this;
    }
    AuditLogDataModalComponent.prototype.formatDate = function (date) {
        return moment(date)
            .tz(this._appState.settings.get(Setting.timezone))
            .format('L LTS');
    };
    AuditLogDataModalComponent.prototype.isArray = function (obj) {
        return obj instanceof Array;
    };
    AuditLogDataModalComponent.prototype.difference = function (arr1, arr2) {
        var common = intersection(arr1, arr2);
        return difference(arr1, common);
    };
    return AuditLogDataModalComponent;
}(UiModalComponent));
export { AuditLogDataModalComponent };
